














import Vue from "vue";

/** Title suffix for features that exist on Windows devices only (the policy sections use the same wording). */
export default Vue.extend({
  name: "WindowsOnlyNote",
});
